import React from 'react';
import { getTag } from './tableUtils';

function possibleHolderStatusTag(
  statusId: string,
  statusDesc: string,
): JSX.Element {
  switch (statusId) {
    case 'A': {
      return getTag('Situação', 'Ativo', 'green');
    }
    case 'AL': {
      return getTag('Situação', 'Aguardando liberação', 'orange');
    }
    case 'P': {
      return getTag('Situação', 'Aguardando análise Operadora', 'orange');
    }
    default: {
      return getTag('Situação', statusDesc, 'orange');
    }
  }
}

export default possibleHolderStatusTag;
